// extracted by mini-css-extract-plugin
export default {"button":"Button_button__+RouV","danger":"Button_danger__AkWX6","transparent":"Button_transparent__eVNVp"};